import { List, Map, OrderedMap } from 'immutable';
import { constants, records } from '@saucelabs/sl-module-invitation';

import * as types from './types';

const initialState = new Map({
  count: 0,
  currentPage: 1,
  loading: true,
  results: new OrderedMap(),
  selectedFilters: new Map({
    status: new List([constants.STATUS_EXPIRED, constants.STATUS_PENDING]),
  }),
  selectedInvitations: new List(),
});

const invitationsReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case types.INVITATION_LIST_GET.SUCCESS: {
      return state.withMutations((mutable) => {
        const invitations = payload.results.reduce((acc, invitation) => {
          acc[invitation.id] = new records.InvitationRecord(invitation);
          return acc;
        }, {});
        mutable.set('loading', false);
        mutable.set('count', payload.count);
        mutable.set('results', new OrderedMap(invitations));
      });
    }
    case types.TOGGLE_INVITATION_SELECTION: {
      const selectedInvitations = state.get('selectedInvitations');
      const index = selectedInvitations
        .findIndex((invitation) => invitation.id === payload.id);

      if (index >= 0) {
        return state.deleteIn(['selectedInvitations', index]);
      }

      return state.set('selectedInvitations', selectedInvitations.push(payload));
    }
    case types.CLEAR_INVITATION_SELECTION:
      return state.set('selectedInvitations', initialState.get('selectedInvitations'));
    case types.UPDATE_OFFSET:
      return state.set('currentPage', payload);
    case types.UPDATE_FILTER:
      return state.withMutations((mutable) => (
        mutable
          .setIn(['selectedFilters', payload.label], payload.value)
          .set('currentPage', 1)
      ));
    case types.TOGGLE_LOADING:
      return state.set('loading', payload);
    case types.INVITATION_RENEW.SUCCESS:
    case types.INVITATION_REVOKE.SUCCESS: {
      if (state.getIn(['results', payload.id])) {
        // Update the invitation only if it's on currently viewed list
        return state.setIn(['results', payload.id], new records.InvitationRecord(payload));
      }
      return state;
    }
    default:
      return state;
  }
};

export default invitationsReducer;
